// Mock NVR General panels until the device info API is available.
export const MOCK_NVR_SYSTEM_INFO = [
  {
    channel: "Ch1",
    name: "Channel 1",
    status: "Online",
    videoFormat: "H264/H264",
    resolution: "3840*2160/704*576",
    bitrate: "600",
  },
  {
    channel: "Ch2",
    name: "Channel 2",
    status: "Online",
    videoFormat: "H265/H265",
    resolution: "4000*3000/1920*1080",
    bitrate: "409",
  },
];

export const MOCK_NVR_HARD_DRIVE_INFO = [
  {
    disk: "Disk 1",
    capacity: "1TB",
    used: "428GB",
    sn: "W610L2BH",
    diskModel: "ST1000NM000-1H162",
    status: "Normal",
  },
  {
    disk: "Disk 2",
    capacity: "2TB",
    used: "385GB",
    sn: "W61034BH",
    diskModel: "ST1000NM000-1H162",
    status: "Normal",
  },
];

export const MOCK_NVR_INTERNET_INFO = {
  status: "Online",
  ip: "192.168.200.249",
  ipv4Cctv: "192.168.99.121",
  subnetMask: "255.255.255.0",
  defaultGateway: "192.168.200.1",
  macAddress: "00:1C:27:35:FA:58",
  dhcp: "On",
  preferredDns: "192.168.200.1",
  alternativeDns: "-",
  totalBandwidth: "1000.00 Mbps",
};
